import React from "react";
import styled from "styled-components";
import { router } from "@inertiajs/react";
import { getOrderHistoryFromLocal } from "../../../../util";

const Container = styled.div`
  min-height: 100vh;
  background: #f9f9f9;
  padding: 20px;
`;

const Wrapper = styled.div`
  max-width: 720px;
  margin: 0 auto;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-size: 24px;
  margin: 0;
`;

const BackButton = styled.button`
  border: none;
  background: transparent;
  color: #333;
  cursor: pointer;
`;

const Card = styled.button`
  width: calc(100% - 24px);
  border: 1px solid #e5e5e5;
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  text-align: left;
  cursor: pointer;
`;

const OrderNumber = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #222;
`;

const Meta = styled.div`
  font-size: 13px;
  color: #666;
  margin-top: 4px;
`;

const Empty = styled.div`
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 16px;
  color: #777;
`;

export default function OrdersIndexPage(props) {
  const { building_code } = props;
  const [orders, setOrders] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const load = async () => {
      const history = getOrderHistoryFromLocal(building_code);
      if (!history.length) {
        setOrders([]);
        setIsLoading(false);
        return;
      }

      const fetched = await Promise.all(
        history.map(async (entry) => {
          try {
            const response = await fetch(`/api/v1/orders/${entry.id}`, {
              headers: { Accept: "application/json" },
            });
            if (!response.ok) return null;
            const payload = await response.json();
            return payload?.data || null;
          } catch (_e) {
            return null;
          }
        }),
      );

      setOrders(fetched.filter(Boolean));
      setIsLoading(false);
    };

    load();
  }, [building_code]);

  return (
    <Container>
      <Wrapper>
        <Header>
          <Title>My Orders</Title>
          <BackButton onClick={() => router.visit(`/hebe/${building_code}/hgs/`)}>
            Back
          </BackButton>
        </Header>

        {isLoading ? (
          <Empty>Loading orders...</Empty>
        ) : orders.length === 0 ? (
          <Empty>No orders found on this device yet.</Empty>
        ) : (
          orders.map((order) => (
            <Card
              key={order.id}
              onClick={() => router.visit(`/hebe/${building_code}/hgs/orders/${order.id}`)}
            >
              <OrderNumber>{order.order_number || order.id}</OrderNumber>
              <Meta>Payment: {order.payment_status || "-"}</Meta>
              <Meta>Delivery: {order.delivery_status || "-"}</Meta>
              <Meta>Total: {order.total || "-"}</Meta>
            </Card>
          ))
        )}
      </Wrapper>
    </Container>
  );
}
